var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleCommunityHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:people-community-24-filled",
    clipPath: "url(#clip0_1421_5491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ri:community-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.02775 20.6018H12.5V13.5902L7.87035 9.55316L3.24072 13.5902V20.6018H6.71294V15.9721H9.02775V20.6018ZM22.9166 22.9166H2.08331C1.77635 22.9166 1.48196 22.7946 1.2649 22.5776C1.04784 22.3605 0.925903 22.0661 0.925903 21.7592V13.0636C0.925885 12.8982 0.961309 12.7347 1.02979 12.5842C1.09827 12.4337 1.19822 12.2995 1.32289 12.1909L5.55553 8.49992V3.24066C5.55553 2.9337 5.67747 2.6393 5.89453 2.42225C6.11159 2.20519 6.40598 2.08325 6.71294 2.08325H22.9166C23.2236 2.08325 23.518 2.20519 23.7351 2.42225C23.9521 2.6393 24.0741 2.9337 24.0741 3.24066V21.7592C24.0741 22.0661 23.9521 22.3605 23.7351 22.5776C23.518 22.7946 23.2236 22.9166 22.9166 22.9166ZM17.1296 11.3425V13.6573H19.4444V11.3425H17.1296ZM17.1296 15.9721V18.287H19.4444V15.9721H17.1296ZM17.1296 6.71288V9.0277H19.4444V6.71288H17.1296ZM12.5 6.71288V9.0277H14.8148V6.71288H12.5Z",
    fill: "#99CC66"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1421_5491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCommunityHome);
export default __webpack_public_path__ + "static/media/people_community_home.92bdb9863053ada74f4500dd43f73801.svg";
export { ForwardRef as ReactComponent };